import React from 'react';
import { useFormContext } from 'react-hook-form';
import FormHelperText from '@mui/material/FormHelperText';
import camelCase from 'lodash/camelCase';
import CustomFieldTypes from '@/constants/customFields/CustomFieldTypes';
// eslint-disable-next-line import/no-cycle -- TODO: Fix this the next time the file is edited.
import useCustomFieldCategoriesAsParams, {
  type CategoryParams,
} from '@/lib/hooks/useCustomFieldCategoriesAsParams';
import translate from '@/lib/intl/translate';
import {
  ALL_CONSTITUENTS_VALUE,
  useSortedCustomFields,
} from '@/modules/Settings';
import type Constituent from '@/types/api/Constituent';
import CustomFieldInput from './CustomFieldInput';

function CustomFields() {
  const {
    formState: { errors },
    watch,
  } = useFormContext();
  const constituent = watch();

  const { categoryParams, resourceValues } = useCustomFieldCategoriesAsParams(
    constituent as Constituent,
  );

  const { sortedCustomFields = [] } = useSortedCustomFields(false, {
    resourceValues,
  });

  return (
    <div className="col-span-full grid grid-cols-1 gap-y-6">
      {sortedCustomFields.map(
        ({ customFields, label, value }) =>
          (value === ALL_CONSTITUENTS_VALUE ||
            categoryParams[camelCase(value) as keyof CategoryParams] ||
            customFields.find(
              (c) => c.customFieldId in constituent.customFields,
            )) &&
          customFields.length > 0 && (
            <div className="grid grid-cols-1 gap-y-6" key={value}>
              {translate('CUSTOM_FIELDS')}{' '}
              {value !== ALL_CONSTITUENTS_VALUE && `- ${label}`}
              {customFields.map((field) => (
                <div key={field.fieldName}>
                  <CustomFieldInput
                    error={!!errors?.customFields?.[field.customFieldId]}
                    {...field}
                  />
                  {!!errors?.customFields?.[field.customFieldId]?.message &&
                    // The date picker component has its own validation message
                    // so its unnecessary here.
                    field.fieldType !== CustomFieldTypes.DATE_PICKER && (
                      <FormHelperText error>
                        {`${errors?.customFields?.[field.customFieldId]
                          ?.message}`}
                      </FormHelperText>
                    )}
                </div>
              ))}
            </div>
          ),
      )}
    </div>
  );
}

export default CustomFields;
